import EnumObject from '@/domain/enum-object.entity';
import RuleGroupItemRequest from './rule-group-item-request'
import RuleGroupItem from './rule-group-item.entity';
import RuleGroupItemParameter from './rule-group-item-parameter.entity';

export default class RuleGroupRequest {
  id: string;

  name: string;

  status: string;

  createdDate: string;

  createdBy: string;

  businessUnitId: string;

  rules: RuleGroupItem[];

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.status = EnumObject.of(obj.status).value;
    this.name = obj.name || '';
    this.createdDate = obj.createdDate || '';
    this.createdBy = obj.createdBy || '';
    this.businessUnitId = obj.businessUnitId;
    this.rules = RuleGroupItem.ofList(obj.rules);
    this.prepareToSend();
  }

  public static of(obj: any = {}): RuleGroupRequest {
    return new RuleGroupRequest(obj || {});
  }

  public static ofList(obj: any[] = []): RuleGroupRequest[] {
    return obj.map(this.of);
  }

  public prepareToSend() {
    this.rules.map((el: RuleGroupItem) => el.parameters
      .forEach((p: RuleGroupItemParameter) => {
        p.validateFormatValues()
      }));
  }
}
